import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import moment from "moment";
import { currencyFormat } from "../../../@dhn/shared/utils";
import { getCompanyReportInfo } from "@dhn/shared/company-info";
pdfMake.vfs = pdfFonts.pdfMake.vfs;


export const awardedOffersReportPdf = (data, period, nameOffer, companyInfo = null) => {
  const companyReportInfo = getCompanyReportInfo(companyInfo);

  const currentDate = new Date().toLocaleDateString('es-ES', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });

  const moneyFormat = currencyFormat({ currencySymbol: "" });

  const groupedData = data.reduce((acc, item) => {
    if (!acc[item.branchOffice.name]) {
      acc[item.branchOffice.name] = [];
    }
    acc[item.branchOffice.name].push(item);
    return acc;
  }, {});

  const documentDefinition = {
    content: [
      {
        stack: [
          {
            columns: [
              {
                image: companyReportInfo.logoDataUrl,
                margin: [50, 0, 0, 0], // Margen [izquierda, arriba, derecha, abajo]
                width: 170,
                style: "header",
              },
              {
                text: '', // Espacio vacío para ajustar
                width: '*', // Ocupa el espacio restante
              }, {
                stack: [
                  {
                    text: "Reporte de Ofertas Otorgadas",
                    decoration: "underline",
                    margin: [50, 50, 0, 0], // Margen [izquierda, arriba, derecha, abajo]
                    width: 270,
                    style: "header",
                    bold: true
                  }, {
                    text: currentDate,
                    margin: [50, 10, 0, 0], // Margen [izquierda, arriba, derecha, abajo]
                    width: 270,
                    style: "header",
                  },
                ],
                width: 300,
              }
            ],
          },
        ],
      },

      //FILA 2

      {
        stack: [
          {
            columns: [
              {
                text: [
                  { text: 'Farmacia: ', bold: true }, // Esto coloca "Farmacia:" en negrita
                  { text: data[0].branchOffice?.name || "", decoration: "underline" }, // Esto deja el contenido subrayado
                ],
                margin: [0, 20, 0, 0],
                width: 230,
                style: "left",
              },
              {
                text: '', // Espacio vacío para ajustar
                width: '*', // Ocupa el espacio restante
              }, {
                text: [
                  { text: 'Aseguradora: ', bold: true },
                  { text: data[0].arsEntity?.name || "", decoration: "underline" },
                ],
                margin: [10, 20, 0, 0],
                width: 200,
                style: "left",
              },
            ],
          },
        ],
      },

      // FILA 3

      {
        stack: [
          {
            columns: [
              {
                text: [
                  { text: 'Linea: ', bold: true },
                  { text: data[0].line?.name || "", decoration: "underline" },
                ], // Aquí asegúrate de que `logo` sea un base64 válido
                margin: [0, 20, 0, 0], // Margen [izquierda, arriba, derecha, abajo]
                width: 325,
                style: "left",
              }, {
                text: [
                  { text: 'Descuento: ', bold: true },
                  { text: `${data[0].discountPercentageOffer || 0}%`, decoration: "underline" },
                ], // Aquí asegúrate de que `logo` sea un base64 válido
                margin: [0, 20, 0, 0], // Margen [izquierda, arriba, derecha, abajo]
                width: 150,
                style: "left",
              },
            ],
          },
        ],
      },

      {
        stack: [
          {
            columns: [
              {
                text: [
                  { text: 'Oferta: ', bold: true },
                  { text: nameOffer, decoration: "underline" },
                ],
                margin: [0, 20, 0, 0],
                width: 325,
                style: "left",
              }, {
                text: [
                  { text: 'Periodo: ', bold: true },
                  { text: `${moment(period.fromDate).format("DD/MM/YYYY")} - ${moment(period.toDate).format("DD/MM/YYYY")}  `, decoration: "underline" },
                ], // Aquí asegúrate de que `logo` sea un base64 válido
                margin: [0, 20, 0, 0], // Margen [izquierda, arriba, derecha, abajo]
                width: 200,
                style: "left",
              },
            ],
          },
        ],
      },

      ...Object.entries(groupedData).map(([name, items]) => ({
        stack: [
          {
            text: [
              { text: "Sucursal: ", bold: true },
              { text: name, decoration: "underline" },
            ],
            margin: [0, 40, 0, 0],
            style: "left",
          },
          {
            style: "tableExample",
            table: {
              widths: [75, 220, 90, 95],
              body: [
                // Encabezados
                [
                  { text: "Fecha", bold: true, alignment: "center" },
                  { text: "Producto", bold: true, alignment: "center" },
                  { text: "Valor Cobertura", bold: true, alignment: "right" },
                  { text: "Valor Descuento", bold: true, alignment: "right" },
                ],
                // Filas
                ...items.map((item) => [
                  { text: moment(item.claimDate).format("DD/MM/YYYY"), alignment: "center" },
                  { text: item.medicine?.name, alignment: "left" },
                  { text: moneyFormat(item.coverageValue), alignment: "right" },
                  { text: moneyFormat(item.discountAmount), alignment: "right" },
                ]),
                // Totales
                [
                  { text: "", border: [false, false, false, false] },
                  { text: "Total", bold: true, alignment: "center" },
                  {
                    text: moneyFormat(
                      items.reduce((acc, item) => acc + item.coverageValue, 0)
                    ),
                    alignment: "right",
                  },
                  {
                    text: moneyFormat(
                      items.reduce((acc, item) => acc + item.discountAmount, 0)
                    ),
                    alignment: "right",
                  },
                ],
              ],
            },
          },
        ],
      })),
    ],


    styles: {
      header: {
        alignment: "center",
      },
      left: {
        alignment: "left",
      },
      tableExample: {
        margin: [0, 10, 0, 0], // Margen [izquierda, arriba, derecha, abajo]
        fontSize: 12, // Tamaño de fuente
        alignment: "center", // Alineación del contenido
      },
    },
  };

  const win = window.open("", "_blank");
  pdfMake.createPdf(documentDefinition).open({}, win);
}
